import { ICON_SELECTOR, swapIcon } from '../helpers/w4d-icon.js';

(function ($) {
	class W4D_Toast {
		constructor() {
			this.NOTICE_DISPLAY_DURATION = 2500;
			this.DEFAULT_SUCCESS_MESSAGE = 'Postavke su uspješno spremnjene';
			this.activeToasts = [];
			this.TOAST_SPACING = 16; // Gap between stacked toasts
		}

		updateToastPositions() {
			let cumulativeOffset = 0;
			this.activeToasts.forEach((toastData) => {
				toastData.$element.css('--toast-offset', cumulativeOffset);
				cumulativeOffset += toastData.height + this.TOAST_SPACING;
			});
		}

		removeToast(toastData) {
			const index = this.activeToasts.indexOf(toastData);
			if (index > -1) {
				this.activeToasts.splice(index, 1);
				this.updateToastPositions();
			}
		}

		showToast(type = 'success', msg = this.DEFAULT_SUCCESS_MESSAGE) {
			const template = $('#toast').prop('content');
			const $toast = $(template).clone();

			// Update the BEM modifier based on type
			const $toastDiv = $toast.find('.toast');
			$toastDiv.removeClass('toast--success toast--error').addClass(`toast--${type}`);

			// Update the icon based on type
			swapIcon($toastDiv.find(`.toast__inner ${ICON_SELECTOR}`), type === 'success' ? 'check' : 'x');

			$toastDiv.find('.toast__text').text(msg);

			// Wire the close button to the toast via the popover invoker API
			const toastId = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
			$toastDiv.attr('id', toastId);
			$toastDiv.find('[data-js-close-toast]').attr('popovertarget', toastId);

			// Toasts live in the top layer, so always append to body
			const $targetContainer = $('body');
			$targetContainer.prepend($toast);

			const $insertedToast = $targetContainer.find('.toast').first();
			$insertedToast[0].showPopover();

			const toastHeight = $insertedToast.outerHeight();

			const toastData = {
				$element: $insertedToast,
				autoRemoveTimer: null,
				height: toastHeight,
			};

			// Add to the beginning of an array (new toasts at index 0)
			this.activeToasts.unshift(toastData);
			this.updateToastPositions();

			$insertedToast.on('animationend', (e) => {
				if (e.originalEvent.animationName === 'fadeOutSlideRight') {
					if ($insertedToast[0].matches(':popover-open')) {
						$insertedToast[0].hidePopover();
					}
					$insertedToast.remove();
					this.removeToast(toastData);
				}
			});

			// Clean up when the popover is closed (e.g. via the close button invoker)
			$insertedToast.on('toggle', (e) => {
				if (e.originalEvent.newState === 'closed') {
					clearTimeout(toastData.autoRemoveTimer);
					$insertedToast.addClass('toast--hidden');
				}
			});

			// Auto remove
			toastData.autoRemoveTimer = setTimeout(() => {
				$insertedToast.addClass('toast--hidden');
			}, this.NOTICE_DISPLAY_DURATION);
		}
	}

	$(document).ready(() => {
		window.W4D_Toast = new W4D_Toast();
	});
})(jQuery);
